import Vue from 'vue'
import Router from 'vue-router'
import privacyAgreement from '@/components/privacyAgreement'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'privacyAgreement',
      component: privacyAgreement
    }
  ]
})


// WEBPACK FOOTER //
// ./src/router/index.js